import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./component/Home-Page/HomePage";
import Introduction from "./component/Introduction/Introduction";
import Solution from "./component/Solution/Solution";
import Customer from "./component/Customer/Customer";
import StoryDetail from "./component/StoryDetail/StoryDetail";
import ContactUs from "./component/Contact-us/ContactUs";
import NewEvent from "./component/NewEvent/NewEvent";
import EventDetail from "./component/EventDetail/EventDetail";
import ConferDetail from "./component/ConferDetail/ConferDetail";
import QuanTri from "./component/Button/QuanTri";
import { AuthProvider } from './component/Management/AuthContext';
import Error404 from "./component/Error404/Error404";
import Policy from "./component/Rules/Policy";
import Clause from "./component/Rules/Clause";
import DeleteAccount from "./component/Delete-Account/DeleteAccount";
import DownLoad from "./component/DownLoad/DownLoad";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route path="/" index element={<Homepage />} />
            <Route path="gioi-thieu" element={<Introduction />}></Route>
            <Route path="giai-phap" element={<Solution />}></Route>
            <Route path="custom" element={<Customer />}></Route>
            <Route path="case-study" element={<StoryDetail />}></Route>
            <Route path="lien-he" element={<ContactUs />}></Route>
            <Route path="tintuc-sukien" element={<NewEvent />}></Route>
            <Route path="tintuc-chitiet/:slug" element={<EventDetail />}></Route>
            <Route path="confer-detail" element={<ConferDetail />}></Route>
            <Route path="chinh-sach" element={<Policy />}></Route>
            <Route path="dieu-khoan" element={<Clause />}></Route>
            <Route path="*" element={<Error404 />} />
            <Route path="delete-account" element={<DeleteAccount />}></Route>
            <Route path="tai-xuong" element={<DownLoad />}></Route>


          </Route>
          <Route path="quan-tri" element={<QuanTri />}></Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
